import { service } from "@ember/service";
import Route from "@ember/routing/route";
import ENV from "glesys-controlpanel/config/environment";

export default class OrganizationNextInvoiceRoute extends Route {
  @service ajax;

  buildRouteInfoMetadata() {
    return { jumpable: true };
  }

  model() {
    let { organization } = this.modelFor("organization");
    return this.ajax.request(`${ENV.apiBaseUri}/invoice/next?organizationnumber=${organization.id}`);
  }
}
